<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted() {
    // document.title = sessionStorage.getItem('labelName') || 'NLIDEA'
    document.title = '深圳鸿阳世纪科技有限公司'
  },
  methods: {}
}
</script>

<style lang="scss">
html,
body {
  min-height: 100%;
  width: 100%;
}
</style>
